(function () {
  const root = document.getElementById('lcm-mobile-menu');
  if (!root || root.dataset.lcmMobileCloseBound === 'true') return;

  const button = root.querySelector('.lcm-mobile-menu-button');
  const wrapper = root.closest('.lcm-horizontal-menu-wrapper') || root.parentElement;
  const overlay = wrapper ? wrapper.querySelector('.mobile-screen') : null;

  if (!button) return;

  function isOpen() {
    return root.classList.contains('nav-open');
  }

  function syncUi() {
    const open = isOpen();

    button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

    if (overlay) {
      overlay.classList.toggle('nav-open', open);
    }
  }

  function resetSubmenus() {
    root.querySelectorAll('.dl-subview, .dl-subviewopen').forEach((el) => {
      el.classList.remove('dl-subview', 'dl-subviewopen');
    });

    root.querySelectorAll('.dl-menuopen').forEach((el) => {
      el.classList.remove('dl-menuopen');
    });
  }

  function closeNav() {
    root.classList.remove('nav-open');
    resetSubmenus();
    syncUi();
  }

  function openNav() {
    root.classList.add('nav-open');
    syncUi();
  }

  button.addEventListener(
    'click',
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (isOpen()) {
        closeNav();
      } else {
        openNav();
      }
    },
    true
  );

  if (overlay) {
    overlay.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeNav();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      closeNav();
    }
  });

  /* Keep overlay state synced even when the theme/plugin closes the menu */
  const observer = new MutationObserver(syncUi);
  observer.observe(root, {
    attributes: true,
    attributeFilter: ['class']
  });

  syncUi();
  root.dataset.lcmMobileCloseBound = 'true';
})();